import useApi from "..";

const useGeneralApi = () => {
    const { request } = useApi(); 
  
    const getNotifications = (limit, offset) => request(`/user/notification?limit=${limit}&offset=${offset}`, 'GET', null);
    
    return { getNotifications };
};

export default useGeneralApi;
